import { Grid } from "@mui/material";
import Template from "../../template/Template";
import TableData from "../../components/Table/TableData";
import { useEffect, useState } from "react";
import { GridColDef } from "@mui/x-data-grid";
import SimpleBackdrop from "../../components/Loading/Simplebackdrop";
import { AlertInfo } from "../../components/Alerts/Alert";
import { api } from "../../services/api";
import { useNavigate } from "react-router-dom";
import { EscritorioType } from "../../types/EscritorioType";
import { displayId } from "../../utils/displayValue";
import moment from "moment";

export default function Escritorios() {
    const navigate = useNavigate();
    const [load, setLoad] = useState(false);
    const [rows, setRows] = useState([]);
    const columns: GridColDef[] = [
        {
            field: 'id_escritorio',
            width: 80,
            headerName: 'CODIGO',
            valueFormatter: (cod: any) => displayId(cod)
        },
        {
            field: 'nome_escritorio',
            width: 500,
            headerName: 'NOME',
        },
        {
            field: 'cnpj_escritorio',
            width: 180,
            headerName: 'CPF CNPJ',
        },
        {
            field: 'cidade_escritorio',
            width: 180,
            headerName: 'CIDADE',
        },
        {
            field: 'telefone_escritorio',
            width: 170,
            headerName: 'TELEFONE',
        },
        {
            field: 'create_escritorio',
            width: 170,
            headerName: 'DATA CADASTRO',
            valueFormatter: (dt: any) => moment(dt).format("DD/MM/YYYY HH:mm")
        },
    ];

    function handleClick(info: EscritorioType) {
        navigate(`/escritorio?id=${info.id_escritorio}`);
    }

    async function loadData() {
        setLoad(true);
        try {
            const response = await api.get(`/escritorios`);
            if (response.data.error) {
                AlertInfo({ icon: 'error', title: response.data.msg });
            } else {
                const data = response.data;
                const dataId = data.map((item: any, index: number) => ({ ...item, id: index }));
                setRows(dataId);
            }
        } catch (error) {
            console.log(error);
            AlertInfo({ icon: 'error', title: 'Falha na conexão' });
        }
        setLoad(false);
    }

    useEffect(() => {
        loadData();
    }, []);

    return (
        <Template menuActive="Escritorios">
            <SimpleBackdrop open={load} />
            <Grid container spacing={1}>
                <Grid size={12}>
                    <TableData
                        rows={rows}
                        columns={columns}
                        handleClick={handleClick}
                        height={500}
                    />
                </Grid>
            </Grid>
        </Template>
    );
}